import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27c19446"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "profile_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "profile_title_text" }, "入力内容の確認")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile_text" }, [
  /*#__PURE__*/_createTextVNode(" この内容でよろしければ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 「この内容で決定する」を押してください ")
], -1))
const _hoisted_4 = { class: "profile_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "卒業区分", -1))
const _hoisted_6 = { class: "profile_item_value" }
const _hoisted_7 = { class: "profile_item_value_text" }
const _hoisted_8 = { class: "profile_education_badge" }
const _hoisted_9 = { class: "profile_education_school_name" }
const _hoisted_10 = { class: "profile_education_school_department" }
const _hoisted_11 = {
  key: 0,
  class: "profile_education_item"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_education_item_title" }, "入学年月", -1))
const _hoisted_13 = { class: "profile_education_item_value" }
const _hoisted_14 = {
  key: 1,
  class: "profile_education_item"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_education_item_title" }, "卒業年月", -1))
const _hoisted_16 = { class: "profile_education_item_value" }
const _hoisted_17 = { class: "profile_button_register" }
const _hoisted_18 = { class: "profile_button_modify" }

import { ref, Ref, computed } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import store from '@/store';
import { useRouter, useRoute } from 'vue-router';
import alertOnReload from '@/utils/alertOnReload';
import { SchoolHistoryInfoItem } from '@/types';

export default /*#__PURE__*/_defineComponent({
  __name: 'EducationConfirmView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const lstschlId: Ref<number> = computed(() => store.getters['careerSheetEducation/lstschlId']);
const scienceFlg: Ref<boolean> = computed(() => store.getters['careerSheetEducation/scienceFlg']);
const schoolHistoryInfoList: Ref<SchoolHistoryInfoItem[]> = computed(() => store.getters['careerSheetEducation/schoolHistoryInfoList']);
const mstListLstSchlObject = computed(() => store.getters['master/mstListLstSchlObject']);
const mstListEntranceObject = computed(() => store.getters['master/mstListEntranceObject']);
const mstListGradObject = computed(() => store.getters['master/mstListGradObject']);

const isLoading = ref(false);

const graduationCategory = computed(() => {
  if (!lstschlId.value) return '';
  const sience = scienceFlg.value ? ' 理系' : '';
  return mstListLstSchlObject.value[lstschlId.value] + sience;
});

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e51', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e51' });
  }
};

const save = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('careerSheetEducation/putAcademicInfo');
    store.dispatch('toasts/appendTimeToast', { label: '学歴を更新しました' });
    if (route.query.ref === 'e') {
      router.push({ name: 'e50', query: { ref: 'e' } });
    } else {
      router.push({ name: 'n50' });
    }
  } catch (error) {
    store.dispatch('toasts/appendTimeToast', { label: '学歴の更新に失敗しました', duration: null });
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(graduationCategory)), 1)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schoolHistoryInfoList), (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "profile_education"
      }, [
        _createElementVNode("div", _hoisted_8, "学歴" + _toDisplayString(index + 1), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(item.schlname), 1),
        _createElementVNode("div", _hoisted_10, _toDisplayString(item.schldeptname), 1),
        (item.entranceFlg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, _toDisplayString(item.entranceyr) + "年" + _toDisplayString(item.entrancemon) + "月 " + _toDisplayString(_unref(mstListEntranceObject)[item.entranceFlg]), 1)
            ]))
          : _createCommentVNode("", true),
        (item.gradFlg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, _toDisplayString(item.gradyr) + "年" + _toDisplayString(item.gradmon) + "月 " + _toDisplayString(_unref(mstListGradObject)[item.gradFlg]), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(BaseButton, {
        theme: "primary",
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode("この内容で決定する")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(BaseButton, {
        theme: "secondary",
        onClick: transitionPreviousPage
      }, {
        default: _withCtx(() => [
          _createTextVNode("修正する")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})